import {IconProps} from './types';

const AiAgentStarIcon = ({fill = 'none', stroke = 'currentColor', className, width = 24, height = 24}: IconProps) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={width}
        height={height}
        viewBox="0 0 24 24"
        fill={fill}
        className={className}
    >
        <path
            stroke={stroke}
            strokeWidth={1.6}
            strokeLinejoin="round"
            d="m12 2.75 2.86 5.8 6.4.93-4.63 4.51 1.09 6.37L12 17.35l-5.72 3.01 1.09-6.37-4.63-4.51 6.4-.93L12 2.75Z"
        />
    </svg>
);

export default AiAgentStarIcon;
